export type EntityKey = 'tapes';

export interface ColumnDef {
  key: string;
  label: string;
  required?: boolean;
  aliases?: string[];
  type?: 'boolean' | 'number';
}

export interface EntityConfig {
  key: EntityKey;
  table: string;
  label: string;
  singular: string;
  icon: string;
  columns: ColumnDef[];
  example?: Record<string, string>;
}

export const entities: EntityConfig[] = [
  {
    key: 'tapes',
    table: 'tapes',
    label: 'Tapes',
    singular: 'tape',
    icon: 'ri-hard-drive-2-line',
    columns: [
      { key: 'media_label', label: 'Media Label', required: true, aliases: ['media label', 'label', 'media', 'tape id'] },
      { key: 'media_set', label: 'Media Set', aliases: ['media set', 'set'] },
      { key: 'backup_set', label: 'Backup Set', aliases: ['backup set', 'backup_set', 'backupset'] },
      { key: 'modified_date', label: 'Modified Date', aliases: ['modified', 'modifieddate', 'date'] },
      { key: 'tape_type', label: 'Tape Type', aliases: ['tape type', 'type'] },
      { key: 'location', label: 'Location', aliases: ['loc', 'site'] },
      { key: 'box_number', label: 'Box Number', aliases: ['box number', 'box', 'box no'] },
      { key: 'notes', label: 'Notes', aliases: ['note', 'remark'] },
      { key: 'needs_replacement', label: 'Needs Replacement', type: 'boolean', aliases: ['needs replacement', 'replacement', 'replace'] },
      { key: 'damaged', label: 'Damaged', type: 'boolean', aliases: ['damaged', 'scrapped', 'scrap'] },
    ],
    example: {
      media_label: 'HC8591',
      media_set: 'Monthly Full Backup',
      backup_set: '',
      modified_date: '03-07-24',
      tape_type: 'Monthly',
      location: 'Shanghai Office',
      box_number: 'BOX-001',
      notes: '',
      needs_replacement: 'false',
      damaged: 'false',
    },
  },
];

export const getEntity = (key: EntityKey): EntityConfig => entities.find((e) => e.key === key)!;

const normalizeHeader = (value: string) => value.toLowerCase().replace(/[\s_\-]/g, '');

export function buildColumnMapping(headers: string[], cols: ColumnDef[]): Record<string, string> {
  const map: Record<string, string> = {};
  const used = new Set<string>();
  cols.forEach((col) => {
    const candidates = [col.label, ...(col.aliases || [])].map(normalizeHeader);
    const found = headers.find((header) => !used.has(header) && candidates.includes(normalizeHeader(header)));
    if (found) {
      map[col.key] = found;
      used.add(found);
    }
  });
  return map;
}
